import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useContext } from "react";

import Sidebar from "../../shared/components/sidebar/Sidebar";
import Navbar from "../../shared/components/navbar/Navbar";
import { AuthContext } from "../../shared/context/auth-context";

import BuildIcon from "@mui/icons-material/Build";

import "./Manutencao.scss";
import UnirClientes from "./unirClientes/UnirClientes";
import TransferirPagamento from "./transferirPagamento/TransferirPagamento";
import TransferirEntreContas from "./transferirEntreContas/TransferirEntreContas";
import TransferirIsoladosParaPlano from "./transferirIsoladosParaPlano/TransferirIsoladosParaPlano";

const SCRIPTS = [
  {
    id: "unirClientes",
    label: "Unir Clientes",
    descricao:
      "Unifica dois registos de cliente num só, transferindo todos os dados.",
    roles: ["Médico/Administrador", "Gerente", "Secretária(o)"],
    componente: <UnirClientes />,
  },
  {
    id: "transferirPagamento",
    label: "Transferir Pagamento de Entrada",
    descricao:
      "Move o pagamento de uma entrada para a conta de um orçamento (parcelas).",
    roles: ["Médico/Administrador", "Gerente", "Secretária(o)"],
    componente: <TransferirPagamento />,
  },
  {
    id: "transferirEntreContas",
    label: "Transferir Pagamento entre Contas",
    descricao:
      "Move o dinheiro de parcelas já pagas de uma conta para as parcelas em aberto de outra conta do mesmo cliente.",
    roles: ["Médico/Administrador", "Gerente", "Secretária(o)"],
    componente: <TransferirEntreContas />,
  },
  {
    id: "transferirIsoladosParaPlano",
    label: "Transferir Tratamentos Isolados para Planos",
    descricao:
      "Passa a execução de tratamentos isolados para o procedimento correspondente de um plano de tratamento, como sessão ou finalização.",
    roles: ["Médico/Administrador", "Gerente", "Secretária(o)"],
    componente: <TransferirIsoladosParaPlano />,
  },
];

function Manutencao() {
  const { aba } = useParams();
  const auth = useContext(AuthContext);

  const [scriptsVisiveis] = useState(() =>
    SCRIPTS.filter((s) => s.roles.includes(auth.role)),
  );

  const [scriptAtivo, setScriptAtivo] = useState(null);

  useEffect(() => {
    if (aba) {
      const encontrado = scriptsVisiveis.find((s) => s.id === aba);
      setScriptAtivo(encontrado?.id ?? scriptsVisiveis[0]?.id ?? null);
    } else {
      setScriptAtivo(scriptsVisiveis[0]?.id ?? null);
    }
  }, [aba, scriptsVisiveis]);

  const scriptCorrente = scriptsVisiveis.find((s) => s.id === scriptAtivo);

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar title="Manutenção" icon={BuildIcon} />

        <div className="manutencao__container">
          {/* ── Menu lateral ───────────────────────────────────────── */}
          <div className="manutencao__menu">
            <p className="manutencao__menu__titulo">Scripts</p>
            {scriptsVisiveis.map((script) => (
              <div
                key={script.id}
                className={`manutencao__menu__item ${
                  scriptAtivo === script.id
                    ? "manutencao__menu__item--active"
                    : ""
                }`}
                onClick={() => setScriptAtivo(script.id)}
              >
                <span className="manutencao__menu__item__nome">
                  {script.label}
                </span>
                <span className="manutencao__menu__item__desc">
                  {script.descricao}
                </span>
              </div>
            ))}

            {scriptsVisiveis.length === 0 && (
              <p className="manutencao__menu__vazio">
                Sem scripts disponíveis para o teu perfil.
              </p>
            )}
          </div>

          {/* ── Conteúdo ───────────────────────────────────────────── */}
          <div className="manutencao__conteudo">
            {scriptCorrente ? (
              <>
                <div className="manutencao__conteudo__cabecalho">
                  <h2 className="manutencao__conteudo__titulo">
                    {scriptCorrente.label}
                  </h2>
                </div>
                {scriptCorrente.componente}
              </>
            ) : (
              <div className="manutencao__conteudo__vazio">
                Seleciona um script no menu lateral.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Manutencao;
